import { resource_types } from 'store/extraResource/constants';

export const extensionActivityIcon = [
  {
    imageUrl:
      'https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/5cfb920a-1d2f-4aeb-d306-9f2765ff4400/public',
    type: resource_types?.comunidad,
  },
  {
    imageUrl:
      'https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/c77bd57b-6e84-4bd9-4b27-d49205c0fd00/public',
    type: resource_types?.resource,
  },
  {
    imageUrl:
      'https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/444c8a96-11a4-43ee-6058-71467ed06500/public',
    type: resource_types?.AP,
  },
  {
    imageUrl:
      'https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/93a90a1c-57a8-438a-0288-4a7361a40000/public',
    type: resource_types?.balcon,
  },
  {
    imageUrl:
      'https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/1df04d5f-0deb-4214-4aeb-f15dfef7f000/public',
    type: resource_types?.story,
  },
  {
    imageUrl:
      'https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/6f779061-ee5b-4626-a147-598f2af49d00/public',
    type: resource_types?.conectándome,
  },
];
